import React from "react";
import Api from "../../components/api/Api";
import { Col, Container, Row } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

const AddPartnerCategory = () => {
  const navigate = useNavigate();

  const addCategoryApi = Api({
    url: `admin/associate/partner/category/add`,
  });

  const initialValues = {
    name: "",
    description: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);

      const data = {
        name: values.name,
        description: values.description,
      };

      const response = await addCategoryApi.postData(data);
      if (response && response.data && response.data.statusType === "SUCCESS") {
        showToast("Partner Category added successfully", {
          type: "success",
        });

        setTimeout(() => {
          navigate("/partner-categories");
        }, 3000);
      } else {
        showToast("Failed to add partner category", {
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
      showToast("Error Occurred", {
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Partners", link: "/partners" },
    { label: "Partner Categories", link: "/partner-categories" },
    { label: "Add Partner Category", link: "", active: true },
  ];

  return (
    <>
      <Notification />
      <Container fluid style={{ marginTop: "2rem", padding: "0rem 4rem" }}>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <SingleDetailHeader
              header="Add Partner Category"
              description="Add a new partner category here."
            />
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <Field
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter category name"
                      name="name"
                      required
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <Field
                      type="text"
                      className="form-control"
                      id="description"
                      placeholder="Enter description"
                      name="description"
                      required
                    />
                    <ErrorMessage
                      name="description"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary mt-4"
                    style={{ marginBottom: "10rem" }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner loading={true} />
                    ) : (
                      "Add Category"
                    )}
                  </button>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddPartnerCategory;
